import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P0003603FunctionFinish } from './P0003603/Installation/P0003603InstallationFinish';
import { P0003603FunctionReset } from './P0003603/Installation/P0003603InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';

export class P0003603Data {
  rbCConfirmationOTA: number = 0;

  rbCResetManuelProtectionMagnetique: number = 0;

  rbCResetManuelProtectionThermique: number = 0;

  rbCResetUsine: number = 0;

  rbCModeFonctionnement: number = 0;

  rbPHorlogeJour: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  rbPHorlogeSemaine: string = '000000000000';

  rbPTypeHorloge: number = 0;

  rbIConfigurationProduit: number = 0;

  rbIActivationProtectionThermique: number = 0;

  rbIActivationProtectionMagnetique: number = 0;

  rbIActivationFonctionAutoMaintienRobot: number = 0;

  rbIActivationPrioriteRobot: number = 0;

  rbISourceDebitReference: number = 0;

  rbICourantNominal: number = 0;

  rbSAlarm: number = 0;

  rbSCommandePompe: number = 0;

  rbSEtatPompe: number = 0;

  rbSEtatProtectionMagnetique: number = 0;

  rbSEtatProtectionThermique: number = 0;

  rbSEtatBouton: number = 0;

  rbSCommandePompeHorloge: number = 0;

  rbSMiseenRouteFiltrationAutoMaintien: number = 0;

  rbSMiseEnRouteFiltrationPrioriteRobot: number = 0;

  rbSArretSurpresseurProtectionDebit: number = 0;

  rbSDetectionDebitReference: number = 0;

  rbSCourantConsommePompe: number = 0;

  rbSNombreCommutationRelais: number = 0;

  rbSTensionSecteur: number = 0;

  rbSPuissanceApparente: number = 0;

  rbSPuissanceActive: number = 0;

  rbSCompteurPuissanceApparenteTotale: number = 0;

  rbSCompteurPuissanceActiveTotale: number = 0;

  rbSCompteurAmpereHeure: number = 0;

  rbSTempsSousTension: number = 0;

  rbSCompteurBouton: number = 0;

  rbSCompteurResetUsine: number = 0;

  rbSCompteurResetManuelProtectionMagnetique: number = 0;

  rbSCompteurResetManuelProtectionThermique: number = 0;
}

export class P0003603 extends IProduct {
  override deviceTableIndex: number = 20;

  override modelIdentifier?: string = 'P00036-03';

  override dataIdentifier?: string = 'P0003603';

  override manufacturerName?: string = 'ACWA';

  data: P0003603Data = new P0003603Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003603/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003603/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003603/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003603;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003603?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003603.tuto.installation.help.title',
      helpSlides: [
        'P0003603.tuto.installation.help.1',
        'P0003603.tuto.installation.help.2',
        'P0003603.tuto.installation.help.3',
        'P0003603.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003603/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003603/installation-1_dark.png',
          },
          text: 'P0003603.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003603/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003603/installation-2_dark.png',
          },
          text: 'P0003603.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003603/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003603/installation-1_dark.png',
          },
          text: 'P0003603.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003603/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003603/update-2_dark.png',
          },
          text: 'P0003603.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          /*{
            component: P0003603InstallationSurpresseur, condition: () => {
              return true;
            },
          },*/
        ],
        finish: P0003603FunctionFinish,
        reset: P0003603FunctionReset,
      },

      controlCards: [
        //{ component: P0003603CardRobotControle, weight: 6 },
      ],

      statusCards: [
        //{ component: P0003603CardRobotStatut, weight: 7 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.ROBOT];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    if (functionnality == IProductFunctionnality.ROBOT) {
      return {
        miseEnOeuvre: {
          pages: [
            /*{
              component: P0003603RobotMiseEnOeuvreCalendrierNettoyageBassin, condition: () => {
                return true;
              },
            },*/
          ],
          //init : P0003603RobotMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,

          //component: P0003603RobotControle,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            //component: P0003603RobotParameters,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          //component: P0003603RobotStatut,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            //component: P0003603RobotHistoriqueSuivi,
          },
        },
      };
    }

    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Robot_Controle,
      propertyName: 'rbCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 19;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).rbIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
